import React, { useState } from "react";

import styles from "./styles.module.scss";
import classNames from "classnames";

type OnSubmitWithEvent = (e: React.MouseEvent<HTMLButtonElement>) => void;
type OnSubmitWithoutEvent = () => void;

type OnSubmitType = OnSubmitWithEvent | OnSubmitWithoutEvent;
interface UIButtonProps {
  title: string;
  onSubmit: OnSubmitType;
  icon?: React.ReactNode;
  disabled?: boolean;
  style?: string;
  textStyle?: string;
  fullWidth?: boolean;
  isLoading?: boolean;
  ariaLabel?: string;
  tabIndex?: number;
  onKeyUp?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  isHidden?: boolean;
}

const UIButton: React.FC<UIButtonProps> = ({
  title,
  onSubmit,
  icon,
  disabled,
  style,
  textStyle,
  fullWidth,
  isLoading,
  ariaLabel,
  tabIndex=0,
  onKeyUp,
  isHidden = false,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!disabled) {
      setIsClicked(true);
      if(onSubmit.length > 0) {
        onSubmit(e);
      } else {
        (onSubmit as OnSubmitWithoutEvent)();
      }
      setTimeout(() => setIsClicked(false), 300);
    }
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLButtonElement>) => {

    if (e.key === "Enter" || e.key === " ") {

      e.preventDefault(); 
      
      if (!disabled) {
        if(onKeyUp) {
          onKeyUp(e);
        } else if(onSubmit.length > 0) {
          (onSubmit as OnSubmitWithEvent)(e as unknown as React.MouseEvent<HTMLButtonElement>);
        } else {
          (onSubmit as OnSubmitWithoutEvent)();
        }
      }
    }
  };

  return (
    <button
      aria-hidden={isHidden}
      onKeyUp={handleKeyUp}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      onClick={handleClick}
      aria-disabled={disabled || isLoading}
      className={classNames(
        !style ? styles.buttonWrapper : style,
        {
          [styles.clicked]: isClicked,
          [styles.disabled]: disabled,
          [styles.buttonFullWidth]: fullWidth,
        }
      )}
    >
      {isLoading ? (
        <div className={styles.loaderWrapper}>
          <div className={styles.loader} />
        </div>
      ) : (
        <>
          <span className={styles.iconWrapper}>{icon}</span>
          <span
            className={classNames(styles.defaultButtonTextStyle, textStyle, {
              [styles.disabledLabel]: disabled,
            })}
          >
            {title}
          </span>
        </>
      )}
    </button>
  );
};

export default UIButton;
